<template>
    <div>
        <b-form role="form" class="mt-4">
            <b-row>
                <b-col cols="12" lg="7">
                    <b-form-group label="Account Type">
                        <el-select v-model="form.account_type" placeholder="Select">
                            <el-option v-for="item in accountTypeList" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" lg="7">
                    <b-form-group label="Bank Name">
                        <el-select v-model="form.bank_name" placeholder="Select">
                            <el-option v-for="item in bankList" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" lg="7">
                    <b-form-group label="Account Name">
                        <b-form-input v-model="form.acc_num" type="text"></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="8">
                    <b-button block variant="primary" class="w-50">Save</b-button>
                </b-col>
            </b-row>
        </b-form>
    </div>
</template>
<script>
import { Select, Option } from 'element-ui';

export default {
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
            form: {
                account_type: '',
                bank_name: '',
                acc_num: ''
            },
            accountTypeList: [
                {
                    value: 'Saving',
                    label: 'Saving Account'
                },
                {
                    value: 'Loan',
                    label: 'Loan Account'
                },
            ],
            bankList: [
                {
                    value: 'Maybank',
                    label: 'Maybank'
                },
                {
                    value: 'RHB Bank',
                    label: 'RHB Bank'
                },
                {
                    value: 'CIMB Bank',
                    label: 'CIMB Bank'
                },
            ]
        }
    }
}
</script>